import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { ToastProvider } from "@/shared/contexts/ToastContext"

// 认证模块
import Login from "./modules/auth/pages/Login"
import Register from "./modules/auth/pages/Register"
import ForgotPassword from "./modules/auth/pages/ForgotPassword"
import ResetPassword from "./modules/auth/pages/ResetPassword"
import UserManagement from "./modules/auth/pages/UserManagement"
import ProtectedRoute from "./modules/auth/components/ProtectedRoute"

// Agent 模块
import Dashboard from "./modules/agent/pages/Dashboard"
import ProjectStudio from "./modules/agent/pages/ProjectStudio"
import ToolManagement from "./modules/agent/pages/ToolManagement"
import SkillManagement from "./modules/agent/pages/SkillManagement"
import ProjectMemory from "./modules/agent/pages/ProjectMemory"
import UserMemoryGraph from "./modules/agent/pages/UserMemoryGraph"
import RuntimeMonitoring from "./modules/agent/pages/RuntimeMonitoring"
import LogManagement from "./modules/agent/pages/LogManagement"
import DeviceManagement from "./modules/agent/pages/DeviceManagement"

// Identity 模块
import { IdentityList, IdentityDetail } from "./modules/identity/pages"
import FacetDetail from "./modules/identity/pages/FacetDetail"

// Memory 模块
import Chat from "./modules/memory/pages/Chat"
import Admin from "./modules/memory/pages/Admin"

// App 管理模块
import { AppList, AppDetail } from "./modules/app"

function App() {
  // API Gateway 基础路径：从环境变量读取
  // - VITE_BASE_PATH=/prod/ → basename='/prod'（API Gateway URL）
  // - VITE_BASE_PATH=/ → basename=''（自定义域名）
  // - 未设置 → basename='/prod'（默认）
  const basePath = import.meta.env.VITE_BASE_PATH
  const basename = basePath === '/' ? '' : (basePath?.replace(/\/$/, '') || '/prod')
  
  return (
    <ToastProvider>
      <Router basename={basename}>
        <Routes>
        {/* 公开路由 */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Agent 模块路由 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id"
          element={
            <ProtectedRoute>
              <ProjectStudio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/memory"
          element={
            <ProtectedRoute>
              <ProjectMemory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/memory/:userId"
          element={
            <ProtectedRoute>
              <UserMemoryGraph />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tools"
          element={
            <ProtectedRoute>
              <ToolManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills"
          element={
            <ProtectedRoute>
              <SkillManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/runtime/monitoring"
          element={
            <ProtectedRoute>
              <RuntimeMonitoring />
            </ProtectedRoute>
          }
        />
        <Route
          path="/runtime/logs"
          element={
            <ProtectedRoute requiredRoles={['admin', 'developer']}>
              <LogManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/devices"
          element={
            <ProtectedRoute requiredRoles={['admin', 'super_admin']}>
              <DeviceManagement />
            </ProtectedRoute>
          }
        />
        
        {/* Identity 模块路由 */}
        <Route
          path="/identities"
          element={
            <ProtectedRoute>
              <IdentityList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/identities/:id"
          element={
            <ProtectedRoute>
              <IdentityDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/identities/:id/facets/:sceneId"
          element={
            <ProtectedRoute>
              <FacetDetail />
            </ProtectedRoute>
          }
        />
        
        {/* Memory 模块路由 */}
        <Route path="/memory" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
        <Route path="/memory/admin" element={<ProtectedRoute requiredRoles={['admin', 'developer']}><Admin /></ProtectedRoute>} />
        
        {/* 管理模块路由 */}
        <Route path="/admin/users" element={<ProtectedRoute requiredRoles={['admin', 'super_admin']}><UserManagement /></ProtectedRoute>} />
        
        {/* App 管理模块路由 */}
        <Route
          path="/apps"
          element={
            <ProtectedRoute requiredRoles={['admin', 'super_admin']}>
              <AppList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/apps/:appId"
          element={
            <ProtectedRoute requiredRoles={['admin', 'super_admin']}>
              <AppDetail />
            </ProtectedRoute>
          }
        />
        
        {/* 默认重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  )
}

export default App
